/**
 * Time left of a session's expected use, how long it is overdue, or "Sem
 * limite". Nothing hands equipment back on its own: past the expected time it
 * stays out, overdue, until the participant scans it again or staff return it.
 */
export function formatRemaining(expiresAt: Date | null | undefined, now = Date.now()): string {
  if (!expiresAt) return 'Sem limite';
  const secs = Math.floor((expiresAt.getTime() - now) / 1000);
  if (secs <= 0) return `Em atraso · ${formatSpan(-secs)}`;
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m ${secs % 60}s`;
}

/** Whether the expected time of use has passed. */
export function isOverdue(expiresAt: Date | null | undefined, now = Date.now()): boolean {
  return !!expiresAt && expiresAt.getTime() <= now;
}

/** A length of time already past, to the minute: "15m", "2h 05m". */
function formatSpan(secs: number): string {
  const minutes = Math.floor(secs / 60);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  return `${m}m`;
}
